import axios from "./AxiosClient";
import { scCatchServiceException } from "../../annotations";
import { PkcePreAuthorization, PkceRedirect } from "./dtos/OauthApplication";
import { Constants } from "@socialcoach/services";

const PKCE_AUTHORIZE_SERVICE = `${Constants.API_URL}/bedrock/api/oauth/authorize`;

export class OauthPkceServices {
  @scCatchServiceException()
  static async getPkceAuthorization(
    client_id: string,
    redirect_uri: string,
    code_challenge: string,
    scope?: string
  ): Promise<PkcePreAuthorization | PkceRedirect> {
    const { data } = await axios.get<PkcePreAuthorization | PkceRedirect>(PKCE_AUTHORIZE_SERVICE, {
      params: {
        client_id,
        redirect_uri,
        code_challenge,
        code_challenge_method: "S256",
        response_type: "code",
        scope,
      },
    });
    return data;
  }

  @scCatchServiceException()
  static async authorizePkce(
    client_id: string,
    redirect_uri: string,
    code_challenge: string,
    scope?: string
  ): Promise<PkceRedirect> {
    const { data } = await axios.post<PkceRedirect>(PKCE_AUTHORIZE_SERVICE, {
      client_id,
      redirect_uri,
      code_challenge,
      code_challenge_method: "S256",
      response_type: "code",
      scope,
    });
    return data;
  }
}
